import { render, staticRenderFns } from "./add-marketing-staff.vue?vue&type=template&id=49f4612f&"
import script from "./add-marketing-staff.vue?vue&type=script&lang=js&"
export * from "./add-marketing-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports